import type { DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { ButtonGroup } from '@/components/ButtonGroup'
import { observer } from 'mobx-react-lite'
import { Button, type ButtonProps } from '@/components/Button'
import { useMemo } from 'react'
import { useProvideWizardBottomBarPrimaryButton } from '@/components/Wizard'

interface DraftJobWizardContentButtonGroupContainerProps {
  vm: DraftJobViewModel
  form: string
}

/**
 * Draft Job Wizard Content Button Group Container
 */
export const DraftJobWizardContentButtonGroupContainer = observer(
  function DraftJobWizardContentButtonGroupContainer({
    vm,
    form,
  }: DraftJobWizardContentButtonGroupContainerProps) {
    const isPending = vm.continue.pending
    const onContinuePress = vm.continue
    const isSkeleton = vm.prepare.pending
    const buttonProps: ButtonProps = useMemo(
      () => ({
        onPress: onContinuePress,
        label: 'Continue',
        isPending,
        isSkeleton,
        form,
        testId: 'draft-job-view-continue-button',
      }),
      [onContinuePress, isPending, isSkeleton, form],
    )

    useProvideWizardBottomBarPrimaryButton(
      vm.isContinueVisible ? buttonProps : null,
    )

    return (
      <>
        <ButtonGroup stretch stacked>
          {vm.isContinueVisible && <Button {...buttonProps} />}
        </ButtonGroup>
      </>
    )
  },
)
